import { render } from "./SottoProgettoPianoFatturazione.vue?vue&type=template&id=1dd95af6&ts=true"
import script from "./SottoProgettoPianoFatturazione.vue?vue&type=script&lang=ts"
export * from "./SottoProgettoPianoFatturazione.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__